var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconOrder38X38 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 38,
  height: 38,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.293 5.542H8.71a3.167 3.167 0 0 0-3.167 3.166v20.584a3.167 3.167 0 0 0 3.167 3.166h20.583a3.167 3.167 0 0 0 3.167-3.166V8.708a3.167 3.167 0 0 0-3.167-3.166ZM14.346 19c0-.437.355-.792.792-.792h11.083a.792.792 0 1 1 0 1.584H15.138a.792.792 0 0 1-.792-.792Zm.792 3.958a.792.792 0 1 0 0 1.584h11.083a.792.792 0 1 0 0-1.584H15.138Zm-.792-8.708c0-.437.355-.792.792-.792h11.083a.792.792 0 1 1 0 1.584H15.138a.792.792 0 0 1-.792-.792Zm-2.185 0a.982.982 0 1 1-1.963 0 .982.982 0 0 1 1.963 0Zm-.981 5.732a.982.982 0 1 0 0-1.964.982.982 0 0 0 0 1.964Zm.981 3.768a.982.982 0 1 1-1.963 0 .982.982 0 0 1 1.963 0Z",
  fill: "#2D91FF"
})));
export default SvgIconOrder38X38;